import React from 'react'
import HeaderIcons from '../../shared/HeaderIcons'


type Item = {
    Icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
    text: string;
    value: number | string | null;
};

type Props = {
    items: Item[];
    showValues: boolean;
    projectsLabel: string;
    containerClassName?: string;
    itemClassName?: string;
    naClassName?: string;
};

const HeaderIconsGroup: React.FC<Props> = ({
    items,
    showValues,
    projectsLabel,
    containerClassName = 'header-icons-content',
    itemClassName = 'content-test',
    naClassName = 'text-na-background',
}) => {
    return (
        <div className={containerClassName}>
            {items.map(({ Icon, text, value }, idx) => (
                <div className='direction-alerts-icons' key={idx}>
                    <div className='size-icon-alerts'>
                        <Icon />
                    </div>
                    <div className='text-icon-alerts'>
                        <div className='text-icon-title'>
                            <p>{text}</p>
                        </div>
                        <div className='text-icon-value'>
                            {showValues ? (
                                <p>{value} {projectsLabel}</p>
                            ) : (
                                <p className={naClassName}>N/A</p>
                            )}
                        </div>
                    </div>
                </div>
            ))}
        </div>
    )
}

export default HeaderIconsGroup